import { Box, Button, Grid, Typography, IconButton, useMediaQuery, useTheme, Avatar, Divider, Skeleton } from "@mui/material";
import { TEXT_LIGHT_COLOR, TEXT_TITLE_COLOR } from "../../../constants/colors";
import { SuppliesMainGroupName } from "../../../models/suppliesMain";
import { useFormMainCategoryController } from "../controller/components";
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import Delete_IC from '../../../assets/images/logo/delete_ic.svg';
import ConfirmDialog from "../../../components/ConfirmDialog";
import FormDivisionView from "./division/form";
import FormCategoryProduct from "./categoryProduct";
import SubCategoryForm from "./subCategory";
import LinearProgress from '@mui/material/LinearProgress';
import { IMAGE_CATEGORY_ROOT_URL } from "../../../constants/imageUrl";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useTranslation } from "react-i18next";

interface Props {
    data: SuppliesMainGroupName[];
    selectedMainId: SuppliesMainGroupName[];
    onClose: VoidFunction;
}

const FormCategoryView = ({ data, selectedMainId, onClose }: Props) => {
    const controllers = useFormMainCategoryController({ data });
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"))
    const { t } = useTranslation('global');
    return (
        <>
            <Box sx={{ display: 'flex' }}>
                <IconButton onClick={onClose}>
                    <KeyboardBackspaceIcon />
                </IconButton>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, mb: 1 }}>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2, width: '100%' }}>
                        <Typography variant="h4" color={TEXT_TITLE_COLOR} fontWeight='bold'>
                            Mg.code : <span>{controllers.getMain?.code}</span>
                        </Typography>
                    </Box>
                </Box>
            </Box>
            <Box sx={{ overflow: 'auto', height: '70vh' }}>
                <Grid container spacing={2} mt={1}>
                    <Grid item xs={12} sm={6} md={3}>
                        <Box p={isSmallScreen ? 1 : 2} sx={{
                            background: '#f5fcff', borderRadius: '15px', boxShadow:
                                '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)'
                            , height: isSmallScreen ? "auto" : '65vh',
                            overflow: 'auto'
                        }}>
                            <Typography variant="h5" mb={1} color={TEXT_TITLE_COLOR} fontWeight='bold'>
                                {t("masterCategory_page.Master Category")}
                            </Typography>
                            <Box sx={{
                                p: 2, borderRadius: '5px', display: 'flex', alignItems: 'center', background: '#ECF8FE', boxShadow:
                                    '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                            }}>
                                <Box>
                                    <Box>
                                        <img src={IMAGE_CATEGORY_ROOT_URL + controllers.getMain?.icon?.url} alt='' style={{ width: '30px', height: '30px' }} />
                                    </Box>
                                    <Typography sx={{ fontSize: 12 }} color={TEXT_TITLE_COLOR}>
                                        {t("masterCategory_page.Name la")} : <span>{controllers.getMain?.main_group_name_la}</span>
                                    </Typography>
                                    <Typography sx={{ fontSize: 12 }} color={TEXT_TITLE_COLOR}>
                                        {t("masterCategory_page.Name en")} : <span>{controllers.getMain?.main_group_name_en}</span>
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Box p={isSmallScreen ? 1 : 2} sx={{
                            background: '#f5fcff', borderRadius: '15px', boxShadow:
                                '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                            height: isSmallScreen ? 'auto' : '65vh'
                        }}>
                            <Typography variant="h5" sx={{ mb: 1 }} color={TEXT_TITLE_COLOR} fontWeight='bold'>
                                {t("masterCategory_page.Division")}
                            </Typography>
                            {
                                controllers.loadingDivision ?
                                    // <>
                                    //     <Box mb={1}>
                                    //         <Skeleton variant="rounded" width='100%' height={100} />
                                    //     </Box>
                                    //     <Box mb={1}>
                                    //         <Skeleton variant="rounded" width='100%' height={100} />
                                    //     </Box>
                                    //     <Box mb={1}>
                                    //         <Skeleton variant="rounded" width='100%' height={100} />
                                    //     </Box>
                                    //     <Box mb={1}>
                                    //         <Skeleton variant="rounded" width='100%' height={100} />
                                    //     </Box>
                                    // </>
                                    <LinearProgress />

                                    : <Box sx={{
                                        height: isSmallScreen ? 'auto' : '60vh',
                                        maxHeight: '60vh',
                                        overflow: 'auto',
                                    }}>
                                        {controllers.dataDivision.map((div, index) => (
                                            <Box
                                                key={index}
                                                sx={{
                                                    p: 1,
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center ',
                                                    backgroundColor: controllers.selectedItemIdOne === div.id ? '#C8FACD' : '#ECF8FE',
                                                    borderRadius: '10px',
                                                    boxShadow:
                                                        '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                                                    mb: 1
                                                }}
                                            >
                                                <Button sx={{ textTransform: 'none', color: 'black', textAlign: 'left', width: '80%', display: 'flex', justifyContent: 'flex-start' }} onClick={() => controllers.handleOpenCategoryProduct(div.id)}>
                                                    <Box>
                                                        <Box>
                                                            <img src={IMAGE_CATEGORY_ROOT_URL + div?.icon?.url} alt="" style={{ width: '30px', height: '30px' }} />
                                                        </Box>
                                                        <Typography sx={{ fontSize: 12 }} color={TEXT_LIGHT_COLOR}>{t("masterCategory_page.Name la")} : <span>{div.division_name_la}</span></Typography>
                                                        <Typography sx={{ fontSize: 12 }} color={TEXT_LIGHT_COLOR}>{t("masterCategory_page.Name en")} : <span>{div.division_name_en}</span></Typography>
                                                    </Box>
                                                </Button>
                                                <Box sx={{ width: '20%' }}>
                                                    <IconButton onClick={() => controllers.handleOpenEditDivision(div.id)}>
                                                        <EditIcon sx={{ width: 18, height: 18 }} />
                                                    </IconButton>
                                                    <IconButton onClick={() => controllers.handleOpenDeleteDivision(div.id)}>
                                                        <img src={Delete_IC} style={{ width: '18px', height: '18px' }} alt="" />
                                                    </IconButton>
                                                </Box>
                                            </Box>
                                        ))}
                                        <Box>
                                            <Button onClick={() => controllers.handleOpenFormDivision()} sx={{ textTransform: 'none', color: TEXT_LIGHT_COLOR }}>
                                                {t("masterCategory_page.Add more")}
                                                &nbsp;
                                                <AddIcon sx={{ width: 15, height: 15 }} />
                                            </Button>
                                        </Box>
                                    </Box>
                            }

                        </Box>

                    </Grid>
                    {
                        controllers.openCategoryProduct && <Grid item xs={12} sm={6} md={3}>
                            <Box p={isSmallScreen ? 1 : 2} sx={{
                                background: '#f5fcff', borderRadius: '15px', boxShadow:
                                    '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                                height: isSmallScreen ? 'auto' : '65vh',
                            }}>
                                <Typography variant="h5" mb={1} color={TEXT_TITLE_COLOR} fontWeight='bold'>
                                    {t("masterCategory_page.Category Product")}
                                </Typography>
                                <Box sx={{
                                    height: isSmallScreen ? 'auto' : '60vh',
                                    maxHeight: isSmallScreen ? 'auto' : '60vh',
                                    overflow: 'auto'
                                }}>
                                    {
                                        controllers.loadingCategories ?
                                            <>
                                                {/* <Box mb={1}>
                                                    <Skeleton variant="rounded" width='100%' height={100} />
                                                </Box>
                                                <Box mb={1}>
                                                    <Skeleton variant="rounded" width='100%' height={100} />
                                                </Box>
                                                <Box mb={1}>
                                                    <Skeleton variant="rounded" width='100%' height={100} />
                                                </Box>
                                                <Box mb={1}>
                                                    <Skeleton variant="rounded" width='100%' height={100} />
                                                </Box> */}
                                                <LinearProgress />
                                            </>
                                            : <>
                                                {controllers.dataCategoryProduct.map((catPro, index) => (
                                                    <Box
                                                        key={index}
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center ',
                                                            backgroundColor: controllers.selectedItemIdTwo === catPro.id ? '#C8FACD' : '#ECF8FE',
                                                            borderRadius: '10px',
                                                            boxShadow:
                                                                '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                                                            mb: 1,
                                                            p: 1,
                                                            width: 'auto'
                                                        }}
                                                    >
                                                        <Button sx={{ textTransform: 'none', color: 'black', justifyContent: 'flex-start', textAlign: 'left', width: '80%' }} onClick={() => controllers.handleOpenSubCategory(catPro.id)}>
                                                            <Box>
                                                                <Box>
                                                                    <img src={IMAGE_CATEGORY_ROOT_URL + catPro?.icon?.url} alt="" style={{ width: '30px', height: '30px' }} />
                                                                </Box>
                                                                <Typography sx={{ fontSize: 12 }} color={TEXT_TITLE_COLOR}>{t("masterCategory_page.Name la")} : <span>{catPro.category_name_la}</span></Typography>
                                                                <Typography sx={{ fontSize: 12 }} color={TEXT_TITLE_COLOR}>{t("masterCategory_page.Name en")} : <span>{catPro.category_name_en}</span></Typography>
                                                            </Box>
                                                        </Button>
                                                        <Box sx={{ width: '20%' }}>
                                                            <IconButton onClick={() => controllers.handleEditCategoryForm(catPro.id)}>
                                                                <EditIcon sx={{ width: 18, height: 18 }} />
                                                            </IconButton>
                                                            <IconButton onClick={() => controllers.handleOpenDeleteCategoryProduct(catPro.id)}>
                                                                <img src={Delete_IC} style={{ width: '18px', height: '18px' }} alt="" />
                                                            </IconButton>
                                                        </Box>
                                                    </Box>
                                                ))}
                                                <Box mt={1}>
                                                    <Button onClick={() => controllers.handleOpenFormCategory()} sx={{ textTransform: 'none', color: TEXT_LIGHT_COLOR }}>
                                                        {t("masterCategory_page.Add more")}
                                                        &nbsp;
                                                        <AddIcon sx={{ width: 15, height: 15 }} />
                                                    </Button>
                                                </Box>
                                            </>
                                    }
                                </Box>
                            </Box>
                        </Grid>
                    }
                    {
                        controllers.openSubCategory && <Grid item xs={12} sm={6} md={3}>
                            <Box p={isSmallScreen ? 1 : 2} sx={{
                                background: '#f5fcff', borderRadius: '15px', boxShadow:
                                    '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                                height: isSmallScreen ? 'auto' : '65vh'
                            }}>
                                <Typography variant="h5" mb={1} color={TEXT_TITLE_COLOR} fontWeight='bold'>
                                    {t("masterCategory_page.Sub Category")}
                                </Typography>
                                <Box sx={{
                                    height: isSmallScreen ? 'auto' : '60vh',
                                    maxHeight: isSmallScreen ? 'auto' : '60vh',
                                    overflow: 'auto',
                                }}>
                                    {
                                        controllers.loadingSubCategory ?
                                            <>
                                                {/* <Box mb={1}>
                                                    <Skeleton variant="rounded" width='100%' height={100} />
                                                </Box>
                                                <Box mb={1}>
                                                    <Skeleton variant="rounded" width='100%' height={100} />
                                                </Box>
                                                <Box mb={1}>
                                                    <Skeleton variant="rounded" width='100%' height={100} />
                                                </Box>
                                                <Box mb={1}>
                                                    <Skeleton variant="rounded" width='100%' height={100} />
                                                </Box> */}
                                                <LinearProgress />
                                            </>
                                            : <>
                                                {controllers.dataSubCategory.map((sub, index) => (
                                                    <Box
                                                        key={index}
                                                        sx={{
                                                            p: 2, borderRadius: '15px', display: 'flex', alignItems: 'center', background: '#ECF8FE', boxShadow:
                                                                '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                                                            width: 'auto', marginBottom: 1
                                                        }}
                                                    >
                                                        <Box sx={{ width: '80%' }}>
                                                            <Box>
                                                                <img src={IMAGE_CATEGORY_ROOT_URL + sub?.icon?.url} alt="" style={{ width: '30px', height: '30px' }} />
                                                            </Box>
                                                            <Typography color={TEXT_LIGHT_COLOR} sx={{ fontSize: 12 }}>{t("masterCategory_page.Name la")}&nbsp;:&nbsp;<span>{sub.sub_category_name_la}</span></Typography>
                                                            <Typography color={TEXT_LIGHT_COLOR} sx={{ fontSize: 12 }}>{t("masterCategory_page.Name en")} :<span>{sub.sub_category_name_en}</span></Typography>
                                                        </Box>
                                                        <Box sx={{ width: '20%' }}>
                                                            <IconButton onClick={() => controllers.handleEditSubCategoryForm(sub.id)}>
                                                                <EditIcon sx={{ width: 18, height: 18 }} />
                                                            </IconButton>
                                                            <IconButton onClick={() => controllers.handleOpenDeleteSubCategory(sub.id)}>
                                                                <img src={Delete_IC} style={{ width: '18px', height: '18px' }} alt="" />
                                                            </IconButton>
                                                        </Box>
                                                    </Box>
                                                ))}
                                                <Box mt={1} ml={isSmallScreen ? -0.5 : -1}>
                                                    <Button onClick={controllers.handleOpenFormSubCategory} sx={{ textTransform: 'none', color: TEXT_LIGHT_COLOR }}>
                                                        {t("masterCategory_page.Add more")}
                                                        &nbsp;
                                                        <AddIcon sx={{ width: 15, height: 15 }} />
                                                    </Button>
                                                </Box>
                                            </>
                                    }
                                </Box>
                            </Box>
                        </Grid>
                    }
                </Grid>
                <ConfirmDialog
                    open={controllers.openDeleteDivision}
                    title="Do you want to delete data ?"
                    loading={controllers.loadingDeleteDivision}
                    onCancel={controllers.handleCloseDeleteDivision}
                    onConfirm={controllers.handleDeleteDivision}
                />
                <FormDivisionView
                    onOpen={controllers.openFormDivision}
                    onClose={controllers.handleCloseFormDivision}
                    mainId={selectedMainId}
                    selectedDiv={controllers.selectedEditDivision}
                    onfetch={controllers.handleFetchDivision}
                    selected={controllers.selectedDiv}
                />
                <ConfirmDialog
                    open={controllers.openDeleteCategoryPro}
                    title="Do you want to delete data ?"
                    loading={controllers.loadingDeleteCategoryPro}
                    onCancel={controllers.handleCloseDeleteCategoryProduct}
                    onConfirm={controllers.handleDeleteCategoryProduct}
                />
                <FormCategoryProduct
                    onOpen={controllers.openFormCategory}
                    onClose={controllers.handleCloseFormCategory}
                    selectedCat={controllers.selectedEditCategory}
                    onfetch={controllers.handleFetchCategoryProduct}
                    DivId={controllers.selectedIdDivision}
                    selected={controllers.selectedCat}
                />
                <ConfirmDialog
                    open={controllers.openDeleteSubcategory}
                    title="Do you want to delete data ?"
                    loading={controllers.loadingDeleteSubCategory}
                    onCancel={controllers.handleCloseDeleteSubCategory}
                    onConfirm={controllers.handleDeleteSubCategory}
                />
                <SubCategoryForm
                    onOpen={controllers.openFormSubCategory}
                    onClose={controllers.handleCloseFormSubCategory}
                    selectedSubCat={controllers.selectedEditSubCategory}
                    onfetch={controllers.handleFetchDataSubCategory}
                    CatProId={controllers.selectedIdCategoryProduct}
                    selected={controllers.selectedSubCat}
                />
            </Box>
        </>
    );
};
export default FormCategoryView;
